module.exports = __webpack_public_path__ + "static/media/gen_img49.5717eeca.png";